import { useNavigate } from 'react-router-dom';

import { Button } from '@mui/material';
import ErrorPage from '../components/pages/errors/ErrorPage';

import { useBreakpoints } from '../hooks/useBreakpoints';
import useError from '../hooks/useError';
import { PATH_AUTH } from '../routes/paths';

const AccessError = () => {
  const navigate = useNavigate();
  const { isLargeMobile } = useBreakpoints();

  const {
    env: { isClockingApp }
  } = window;

  const {
    clockingApp: { login: loginCometeOnTime },
    login
  } = PATH_AUTH;

  const {
    picture: onTimePict,
    title: onTimeTitle,
    subtitle: onTimeSub
  } = useError({ code: 'ON_TIME_APP_ACCESS_FORBIDDEN' });

  const { picture: linkPicture, title: linkTitle, subtitle: linkSub } = useError({ code: 'LINK_APP_ACCESS_FORBIDDEN' });

  // Determine the error content based on app (isClockingApp = Comète On Time)
  const getErrorContent = (isClockingApp) =>
    isClockingApp
      ? { picture: onTimePict, title: onTimeTitle, subtitle: onTimeSub }
      : { picture: linkPicture, title: linkTitle, subtitle: linkSub };

  const { picture, title, subtitle } = getErrorContent(isClockingApp);

  const handleClickBack = () => {
    if (window.history.state.idx) {
      window.history.back();
    } else {
      navigate(isClockingApp ? loginCometeOnTime : login);
    }
  };

  const action = (
    <Button
      variant="contained"
      size="large"
      sx={{ alignSelf: isLargeMobile ? 'stretch' : null }}
      onClick={handleClickBack}
    >
      Retour
    </Button>
  );

  return <ErrorPage picture={picture} title={title} subtitle={subtitle} actions={action} />;
};

export default AccessError;
